import { SharedAccess, UserAccess, UserModelRole } from "target_wasm";

enum ResourceType {
  Model = "Model",
  Table = "Table",
  Dataset = "Dataset",
}
enum Permission {
  CanImport = "SharedWith",
  CanShare = "SharedWithReshare",
}

interface RemoveAccessData {
  email?: string;
  clientId?: string;
  oldRole: string;
  isPending?: boolean;
}

export interface ShareOutcome {
  atCapacityEmails?: string[];
  /// Addresses a partial-success door (datasets) refused while serving the
  /// rest. The table door never populates this — it refuses whole batches.
  refusedEmails?: string[];
}

interface InputShareFieldProps {
  entityId: string;
  /// May resolve with the addresses that could not be invited because the
  /// account cap is full. The share still succeeded for everyone else, so this
  /// is a warning on a success, not a failure.
  shareAction: (
    emails: string[],
    accessLevel: UserModelRole | Permission | null,
  ) => void | Promise<ShareOutcome | void>;
  sharedWith: SharedAccess | undefined;
  resourceType: ResourceType;
  defaultRole: UserModelRole | null;
  defaultPermission: Permission | null;
  className?: string;
  setIsShare: React.Dispatch<React.SetStateAction<boolean>>;
  setNewSharedWith?: React.Dispatch<React.SetStateAction<SharedAccess>>;
  canRevokeAccess?: boolean;
  /// Keep the input visible but block the Share action (e.g. a dataset/table
  /// that needs a published release first). Distinct from `canShare`, which
  /// hides the composer entirely for viewers.
  shareDisabled?: boolean;
}

export const filterSharedWith = (
  sharedWith: SharedAccess | undefined,
  userCurrentEmail: string | null,
): UserAccess[] => {
  return (
    sharedWith
      ?.users()
      ?.filter(
        (userAccess) =>
          userAccess.user_js().user_email_js() !== userCurrentEmail,
      ) ?? []
  );
};

export const validateEmail = (email: string) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export interface RefetchOptions {
  search?: string;
  continuationToken?: string | null;
  limit?: number;
}

export type { InputShareFieldProps, RemoveAccessData };
export { Permission, ResourceType };
